<template>
	<div
		class="nearby"
		@click="$emit('on-click', data.cinemaid, data.cinema_name)"
	>
		<div class="nearby-tag">
			<!-- <img :src="require('@/assets/images/movie/28x28.png')"/> -->
			<img :src="require('@/assets/images/movie/120x120.png')" />
		</div>
		<div class="no">{{ no }}</div>
		<div class="fx-fill">
			<div class="name van-multi-ellipsis--l">{{ data.cinema_name }}</div>
			<div class="address van-multi-ellipsis--l">{{ data.cinema_addr }}</div>
		</div>
		<div class="distance">
			<span v-if="data.distance">{{ data.distance_text }}</span>
			<!-- <span v-if="data.distance">{{data.distance | formatDistance}}</span> -->
		</div>
	</div>
</template>

<script>
export default {
	props: {
		no: Number,
		data: {
			type: Object,
			default: () => {
				return {};
			},
		},
	},
};
</script>

<style lang="scss" scoped>
.nearby {
	position: relative;
	display: flex;
	flex-direction: row;
	padding: 12px 12px;
	padding-left: 0;
	align-items: center;
	border-bottom: 1px solid #eff1f8;
	.nearby-tag {
		position: absolute;
		top: 0;
		left: 0;
		img {
			width: 30px;
			height: 30px;
		}
	}
	// .nearby-tag {
	//     position: absolute;
	//     top: 0;
	//     left: 0;
	//     width: 0;
	//     height: 0;
	//     border-width: 25px 25px 0 0;
	//     border-style: solid;
	//     border-color: #1482FF transparent transparent transparent;
	// }
	// .nearby-tag::after {
	//     position: absolute;
	//     content: "附近";
	//     display: block;
	//     width: 25px;
	//     height: 25px;
	//     font-size: 2px;
	//     text-align: center;
	//     left: 2px;
	//     top: -23px;
	//     transform: rotate(-45deg);
	//     color: #fff;
	// }
	.no {
		height: 100%;
		padding: 0 15px;
		padding-left: 20px;
		font-size: 18px;
	}
	.name {
		font-size: 15px;
		color: #3f4956;
	}
	.address {
		margin-top: 4px;
		color: $tips-color;
	}
	.distance {
		margin-left: 10px;
		color: $tips-color;
		// font-size: 14px;
	}
}
.van-multi-ellipsis--l {
	display: -webkit-box;
	overflow: hidden;
	text-overflow: ellipsis;
	-webkit-line-clamp: 1;
	-webkit-box-orient: vertical;
}
</style>
